module.exports = __webpack_public_path__ + "img/icon_wenjianrar.e8cb7547.svg";